import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { StageService } from '../../services'

/**
 * Nicht-Produktiv-Hinweis („Test-Umgebung" / „Demo-Umgebung") als Streifen über die volle Breite.
 * Auf Produktion rendert die Komponente nichts — Aufrufer brauchen kein eigenes `@if` auf `isProd()`.
 *
 * Eingebaut in `lib-navigation` (über der Toolbar) und im Selfservice (`app.component.html`).
 */
@Component({
  selector: 'lib-stage-bar',
  imports: [],
  templateUrl: './stage-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './stage-bar.component.scss',
})
export class StageBarComponent {
  readonly stageService = inject(StageService)
}
